// NX text input (shadcn Input restyled): 36 px, hairline input border, blue focus border with a 3 px ring, invalid state in brand red.
import type * as React from "react";

import { cn } from "@/lib/cn";

const inputBase =
  "w-full min-w-0 rounded-sm border border-input bg-card text-btn text-foreground transition-[border-color,box-shadow] duration-150 outline-none placeholder:text-muted-foreground focus-visible:border-input-focus focus-visible:shadow-[0_0_0_3px_var(--input-ring)] focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-45 aria-invalid:border-brand-text";

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        inputBase,
        "h-9 px-2.5 file:mr-2 file:border-0 file:bg-transparent file:text-ui file:font-medium file:text-foreground",
        className,
      )}
      {...props}
    />
  );
}

export { Input, inputBase };
